const scrollIntoView = (id: string, callback?: () => void) => {
  requestAnimationFrame(() => {
    try {
      const scrollContainerRef = document.querySelector(id);
      scrollContainerRef?.scrollIntoView({ behavior: 'smooth' });
      callback?.();
    } catch (error) {
      console.error(error);
    }
  });
};

export default scrollIntoView;
